const setAXPLocaleCookie = (locale) => {
  if (!locale) return;
  try {
    document.cookie = `axplocale=${locale}; path=/ ;domain=.americanexpress.com`;
  } catch (error) {
    // this can fail if the cookie is blocked
    console.error(`setAXPLocaleCookie error: ${error?.message}`);
  }
};

export default setAXPLocaleCookie;
